export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTH = 'both';
